export const specialFont = '"audiowide", sans-serif';
export const mainFont = '"Inter", sans-serif';
